import { ProjectApiImages } from "../../../containers/create-proposal/props";
import { Dict } from "../../models";
import {
  ApiResponse,
  TokenData,
  ProposalReason,
  ProposedPropertyDetails,
  DraftProposalStatus,
  UpdateSendProposalStatusDto,
  Proposal,
  Participant,
  ListSort,
  PaginatedApiResponse,
} from "../models";
import * as http from "./http";
import ApiService from "./service";

export class ProposalService extends ApiService {
  public async loadAllProposalReason(data: any) {
    const url = `${this.apiDomain}/api/reasons/list`;

    const resposne = await http.post<ApiResponse<ProposalReason[]>>(
      url,
      data,
      this.store
    );
    return resposne?.data?.data;
  }

  public async loadAllProposalCoverImages(data?: string[]) {
    const url = `${this.apiDomain}/api/proposal-image/list`;

    const response = await http.post<ApiResponse<any>>(
      url,
      { propertyTypes : data || []},
      this.store
    );
    return response?.data?.data || [];
  }
  public async loadAllProjectImages(data?: string[] | undefined) {
    const url = `${this.apiDomain}/api/project/images`;

    const response = await http.post<ProjectApiImages[]>(
      url,
      { projectIds : data || []},
      this.store
    );
    return response?.data || [];
  }

  public async createProposalReason(data: any, id?: string) {
    const url = `${this.apiDomain}/api/reasons`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async updateProposalReason(data: any, id?: string) {
    const url = `${this.apiDomain}/api/reasons/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async addProposalImages(data: any) {
    const url = `${this.apiDomain}/api/proposal-image/add`;

    const response = await http.post<ApiResponse<any>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteProposalCoverImage(id?: string) {
    const url = `${this.apiDomain}/api/proposal-image/${id}`;

    const response = await http.remove<ApiResponse<any>>(url, this.store);
    return response.data;
  }

  public async deleteProposalReason(id?: string) {
    const url = `${this.apiDomain}/api/reasons/${id}`;

    const response = await http.remove<ApiResponse<any>>(url, this.store);
    return response.data;
  }

  async createProposal(data: any) {
    const url = `${this.apiDomain}/api/proposal`;
    const response = await http.post<ApiResponse<any>>(url, data, this.store);
    return response.data;
  }

  async updateProposal(data: any, id: string) {
    const url = `${this.apiDomain}/api/proposal/${id}`;
    const response = await http.put<ApiResponse<any>>(url, data, this.store);
    return response.data;
  }

  public async listProposedProperties(data: {
    requirementId?: string;
  }): Promise<ProposedPropertyDetails> {
    const url = `${this.apiDomain}/api/proposal/list`;

    const resposne = await http.post<ApiResponse<ProposedPropertyDetails>>(
      url,
      data,
      this.store
    );
    return resposne.data?.data;
  }

  public async updateDraftStatus(
    propertyIds: string[],
    status?: DraftProposalStatus,
    rejectReason?: string,
    comment?: string
  ) {
    const url = `${this.apiDomain}/api/proposal/update/draft-status`;

    const response = await http.post<ApiResponse<Proposal>>(
      url,
      { propertyIds, status, rejectReason, comment },
      this.store
    );
    return response.data;
  }

  public async moveToCSLInitial(propertyIds: string[], requirementId?: string) {
    const url = `${this.apiDomain}/api/proposal/move-to-csl-initial`;

    const response = await http.post<ApiResponse<Proposal>>(
      url,
      { propertyIds, requirementId },
      this.store
    );
    return response.data;
  }

  public async moveToCSLFinal(propertyIds: string[], requirementId?: string) {
    const url = `${this.apiDomain}/api/proposal/move-to-csl-final`;

    const response = await http.post<ApiResponse<Proposal>>(
      url,
      { propertyIds, requirementId },
      this.store
    );
    return response.data;
  }

  public async deleteFromCSLInitial(
    propertyIds: string[],
    requirementId?: string
  ) {
    const url = `${this.apiDomain}/api/proposal/delete-from-csl-initial`;

    const response = await http.post<ApiResponse<Proposal>>(
      url,
      { propertyIds, requirementId },
      this.store
    );
    return response.data;
  }

  public async updateSendProposalStatus(data?: UpdateSendProposalStatusDto) {
    const url = `${this.apiDomain}/api/proposal/update/send-proposal-status`;

    const response = await http.post<ApiResponse<Proposal>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  async getProposalPreview(data: any) {
    const url = `${this.apiDomain}/api/proposal/proposal-preview`;
    const response = await http.post<ApiResponse<any>>(url, data, this.store);
    return response.data;
  }

  async findProposalById(proposalId: string) {
    const url = `${this.apiDomain}/api/proposal/${proposalId}`;
    const response = await http.get<ApiResponse<Proposal>>(url, this.store);
    return response.data?.data;
  }

  // async downloadProposalPdf(
  //   requirementId: string,
  //   proposalId: string,
  //   title: string
  // ) {
  //   const url = `${this.apiDomain}/api/proposal/download-pdf`;
  //   const reponse = await http.downloadPostData(
  //     url,
  //     { requirementId, proposalId },
  //     this.store
  //   );
  //   http.saveDownloadedFile(
  //     reponse.data,
  //     "application/pdf",
  //     `${title || "Proposal"}.pdf`
  //   );
  //   return;
  // }

  async downloadProposalPdf(
    requirementId: string,
    proposalId: string,
    title: string,
    htmlContent:any
  ) {
    const apiUrl = `${this.apiDomain}/api/proposal/download/pdf-preview`;
    const reponse = await http.downloadPostData(
      apiUrl,
      { requirementId, proposalId, htmlContent },
      this.store
    );
    http.saveDownloadedFile(
      reponse.data,
      "application/pdf",
      `${title || "Proposal"}.pdf`
    );
    return;
  }

  public async revokeDraftStatus(proposedDocumentIds: string[]) {
    const url = `${this.apiDomain}/api/proposal/revoke/draft-status`;

    const response = await http.post<ApiResponse<Proposal>>(
      url,
      { proposedDocumentIds },
      this.store
    );
    return response.data;
  }

  public async sendProposalEmail(requirementId: string, proposalId: string, htmlContent: any) {
    const url = `${this.apiDomain}/api/proposal/send-proposal-email`;

    const response = await http.post<ApiResponse<Proposal>>(
      url,
      { requirementId, proposalId, htmlContent },
      this.store
    );
    return response.data;
  }

  public async loadAllProposalSendReason() {
    const url = `${this.apiDomain}/api/reasons/list`;

    const resposne = await http.post<ApiResponse<ProposalReason[]>>(
      url,
      {
        entityType: "ProposalSend",
      },
      this.store
    );
    return resposne?.data?.data;
  }

  public async createProposalSendReason(data: any, id?: string) {
    const url = `${this.apiDomain}/api/reasons`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async updateProposalSendReason(data: any, id?: string) {
    const url = `${this.apiDomain}/api/reasons/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteProposalSendReason(id?: string) {
    const url = `${this.apiDomain}/api/reasons/${id}`;

    const response = await http.remove<ApiResponse<any>>(url, this.store);
    return response.data;
  }

  public async loadAllProposalRejectReason() {
    const url = `${this.apiDomain}/api/reasons/list`;

    const resposne = await http.post<ApiResponse<ProposalReason[]>>(
      url,
      {
        entityType: "ProposalReject",
      },
      this.store
    );
    return resposne?.data?.data;
  }

  public async createProposalRejectReason(data: any, id?: string) {
    const url = `${this.apiDomain}/api/reasons`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async updateProposalRejectReason(data: any, id?: string) {
    const url = `${this.apiDomain}/api/reasons/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteProposalRejectReason(id?: string) {
    const url = `${this.apiDomain}/api/reasons/${id}`;

    const response = await http.remove<ApiResponse<any>>(url, this.store);
    return response.data;
  }

  public async getParticipants(id?: string) {
    const url = `${this.apiDomain}/api/proposal/${id}/peoples`;

    const resposne = await http.get<ApiResponse<Participant[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async getPropertyStatusByRequirementId(id: string) {
    const url = `${this.apiDomain}/api/proposal/proposed-property-status/${id}`;
    const resposne = await http.get<ApiResponse<any>>(url, this.store);
    return resposne?.data;
  }

  public async getProposal(
    data: {
      page: number;
      search?: string;
      perPage: number;
      isDeal?: boolean;
      customerId?: string;
      applyVisibilityFilter?: boolean;
    } & ListSort &
      Dict
  ): Promise<PaginatedApiResponse<Proposal> & { lastUpdatedAt: Date }> {
    const url = `${this.apiDomain}/api/proposal/list-proposals`;

    const resposne = await http.post<PaginatedApiResponse<Proposal>>(
      url,
      data,
      this.store
    );
    return { ...resposne.data, lastUpdatedAt: new Date() };
  }

  public async getProposalList(
    data: {
      page?: number;
      search?: string;
      perPage?: number;
    } & ListSort &
      Dict
  ): Promise<PaginatedApiResponse<any[]>> {
    const url = `${this.apiDomain}/api/proposal/list-proposals`;
    const response = await http.post<PaginatedApiResponse<any[]>>(
      url,
      data,
      this.store
    );

    return response?.data;
  }
}
